import React, { FC } from 'react';
import { CalculatorsAndImageCardFragment } from '../../types/graphqlTypes';
import { Grid } from '../Grid';
import { ImageCardRenderer } from '../ImageCardRenderer';
import { Section } from '../Section';
import { MortgageEstimator } from './MortgageEstimator';
import { StampDutyCalculator } from './StampDutyCalculator';

interface CalculatorsAndImageCardProps extends Omit<CalculatorsAndImageCardFragment, '__typename'> {
  purchasePrice?: number;
}
export const CalculatorsAndImageCard: FC<CalculatorsAndImageCardProps> = ({
  imageCard,
  purchasePrice,
  backgroundColour,
  ...rest
}) => (
  <Section contained background={backgroundColour || 'grey'} {...rest}>
    <Grid>
      <MortgageEstimator defaultRepaymentTerm={25} defaultInterestRate={4.22} defaultPurchasePrice={purchasePrice} />
      <StampDutyCalculator purchasePrice={purchasePrice} />
      {imageCard && <ImageCardRenderer {...imageCard} vertical />}
    </Grid>
  </Section>
);
